var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(message){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.messages && _vm.messages.length > 0),expression:"messages && messages.length > 0"}],staticClass:"uk-alert",class:{
            'uk-alert-success': message.type === 'success',
            'uk-alert-warning': message.type === 'warning',
            'uk-alert-danger': message.type === 'error'
         }},[_c('span',[_vm._v(_vm._s(message.message))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }